import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, PLATFORM_INITIALIZER, APP_INITIALIZER, Injector, APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { DelonACLModule } from '@delon/acl';
import { DelonCacheModule } from '@delon/cache';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
// main ui lib
import { NgDragDropModule } from 'ng-drag-drop';
import { SharedModule } from '@root/shared/shared.module';
import { SortablejsModule } from 'ngx-sortablejs';
// custom module
import { AppRouteModule } from '@root/app-route.module';
import { PagesModule } from '@root/router/pages.module';
// import { ComponentModule } from '@root/component/component.module';
// main component
import { AppComponent } from '@root/app.component';

/** 配置 angular i18n **/

import { environment } from '../environments/environment';
import { InjectorService } from './injector.service';

//#region Register Language
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
registerLocaleData(zh);
//#endregion

//#region Startup Service
import { StartupService } from './startup.service';
export function StartupServiceFactory(startupService: StartupService): () => Promise<void> {
  return () => startupService.load();
}
const APPINIT_PROVIDES = [
  StartupService,
  {
    provide: APP_INITIALIZER,
    useFactory: StartupServiceFactory,
    deps: [StartupService],
    multi: true
  }
];
//#endregion

//#region http Interceptors
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MockInterceptor } from '@root/shared/interceptor/mock.interceptor';
import { AuthInterceptor } from '@root/shared/interceptor/auth.interceptor';
import { ParamsFilterInterceptor } from '@root/shared/interceptor/params-filter.interceptor';
// import { PiwikInterceptor } from '@root/shared/interceptor/piwik.interceptor';
const INTERCEPTOR_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: MockInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ParamsFilterInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: PiwikInterceptor, multi: true }
];
//#endregion

//#region Translate Loader
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
const LOADER = { provide: TranslateLoader, useFactory: (createTranslateLoader), deps: [ HttpClient ] };
//#endregion

//#region Const Config
import { GLOBAL_CONFIG_TOKEN, GlobalConfig} from '@root/config';
// import { AlainConfigService } from '@delon/util';
const CONFIG_PROVIDERS = [
  { provide: GLOBAL_CONFIG_TOKEN, useValue: GlobalConfig }
];
//#endregion

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DelonCacheModule,
    DelonACLModule.forRoot(),
    TranslateModule.forRoot({
      loader: LOADER,
      defaultLanguage: 'cn'
    }),
    NgDragDropModule.forRoot(),
    SortablejsModule.forRoot({ animation: 150 }),

    SharedModule,
    PagesModule,
    AppRouteModule,
  ],
  providers: [
    // environment.production ? null : {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MockInterceptor,
    //   multi: true
    // },
    // AlainConfigService,
    ...INTERCEPTOR_PROVIDERS,
    ...APPINIT_PROVIDES,
    ...CONFIG_PROVIDERS,
    // ...tokens,
    // { provide: NZ_I18N, useValue: zh_CN }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    InjectorService.injector = this.injector;
  }
}
